export const WEIGHTING = {
    "Criteria" : {
        "Price": 30,
        "Hardware Availability": 5,
        "Path Selection": 4,
        "Transport Layer Connectivity": 4,
        "Routing Capabilities": 3,
        "Resiliency & Failover": 4,
        "Geographic Coverage": 3,
        "Support": 2,
        "New Rollout": 2,
        "Scalability": 3,
        "Management": 3,
        "Troubleshooting": 2,
        "Technical Support": 3,
        "Reporting / Analytics": 2,
        "App Aware": 5,
        "Security Policy": 3,
        "Secure Edge": 3,
        "NAT": 1,
        "Encryption/International Export Policies": 3,
        "Firewall Capabilities": 3,
        "Layer 4-7": 4,
        "Segmentation Capability": 3,
        "DDOS Protection": 3,
        "FIPS Compliant": 2
    }
}